import "./ContactUs.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import ContactStars from "./sections/ContactStars";
import FindUsHere from "./sections/FindUsHere";
import FooterInformation from "@/reusable_sections/Footer";
export default function ContactUsPage() {
  return <div>
      <NavigationHeader />
      <ContactStars />
      <FindUsHere />
      <FooterInformation />
    </div>;
}